module.exports = __webpack_public_path__ + "static/media/icon_left.b2f115f7.svg";